export interface RssItem { title: string; description: string; link: string; pubDate: string; }

export const parseRSS = (raw: string): RssItem[] => {
  // Try XML (RSS) first
  try {
    const doc = new DOMParser().parseFromString(raw, 'application/xml');
    const xmlItems = Array.from(doc.querySelectorAll('item'));
    if (xmlItems.length) {
      return xmlItems.map(el => ({
        title: el.querySelector('title')?.textContent || '',
        description: (el.querySelector('description')?.textContent || '').replace(/<[^>]+>/g, '').slice(0, 160),
        link: el.querySelector('link')?.textContent || '',
        pubDate: el.querySelector('pubDate')?.textContent || '',
      }));
    }
    // Atom (the Talos blog is a Blogger feed): entries, with the post URL in <link rel="alternate" href>
    const entries = Array.from(doc.querySelectorAll('entry'));
    if (entries.length) {
      return entries.map(el => {
        const links = Array.from(el.querySelectorAll('link'));
        const post = links.find(l => l.getAttribute('rel') === 'alternate') || links[0];
        const body = el.querySelector('summary')?.textContent || el.querySelector('content')?.textContent || '';
        return {
          title: el.querySelector('title')?.textContent || '',
          description: body.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim().slice(0, 160),
          link: post?.getAttribute('href') || '',
          pubDate: el.querySelector('published')?.textContent || el.querySelector('updated')?.textContent || '',
        };
      });
    }
  } catch { /* not XML */ }
  // Fallback: try JSON
  try {
    const data = JSON.parse(raw);
    const arr: any[] = Array.isArray(data) ? data : data?.items || data?.articles || [];
    return arr.slice(0, 10).map((item: any) => ({
      title: item.title || '',
      description: (item.description || item.summary || '').replace(/<[^>]+>/g, '').slice(0, 160),
      link: item.link || item.url || '',
      pubDate: item.pubDate || item.date || item.published || '',
    }));
  } catch { return []; }
};
